import styled from 'styled-components'

const DaneIdentyfikacyjneStyle = styled.div`
  .checkboxLabel {
    height: auto;
    align-items: flex-start;
    margin: 0;
  }

  .checkboxLabel .MuiFormControlLabel-label {
    white-space: normal;
    line-height: 1.4;
    margin-top: 2px;
  }

  .checkboxLabel .MuiCheckbox-root {
    padding-top: 0;
  }

  .identyfikacjaPodmiotu {
    width: 100%;
    display: grid;
    grid-row-gap: 24px;
  }

  .identyfikacjaPodmiotu .pkd {
    width: 100%;
    padding-bottom: 20px;
  }

  .identyfikacjaPodmiotu .formaPrawnaRow {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 16px;
  }

  .identyfikacjaPodmiotu .krs {
    display: grid;
    grid-auto-flow: column;
    grid-gap: 16px;
    justify-content: start;

    .text {
      width: 184px;
    }
  
  }

  .identyfikacjaPodmiotu .buttonGUS {
      margin-top: 12px;
      //  margin-left: 16px;
    }
  
  .siedzibaR2 {
    width: 100%;
    display: grid;
    grid-template-rows: auto auto;
    grid-row-gap: 24px;
  }

  .siedzibaR2 .wariantSiedziby {
    margin-top: -8px;
  }

  .siedzibaR2Polska {
    display: grid;
    grid-template-rows: auto auto auto;
    grid-row-gap: 24px;
  }

  .siedzibaR2Polska .firstRow {
    display: grid;
    grid-template-columns: 304px 304px 344px;
    grid-column-gap: 16px;
  }

  .siedzibaR2Polska .secondRow {
    display: grid;
    grid-template-columns: 424px 104px 84px;
    grid-column-gap: 16px;
  }

  .siedzibaR2Polska .thirdRow {
    display: grid;
    grid-template-columns: 304px 104px 84px;
    grid-column-gap: 16px;
  }

  .siedzibaR2Zagraniczna {
    display: grid;
    grid-template-rows: auto auto;
    grid-row-gap: 24px;
  }

  .siedzibaR2Zagraniczna .secondRow {
    display: grid;
    grid-template-columns: 424px 104px 84px;
    grid-column-gap: 16px;
  }

  .siedzibaR2Zagraniczna .thirdRow {
    display: grid;
    grid-template-columns: 104px 304px 84px;
    grid-column-gap: 16px;
  }


  .siedziba {
    width: 100%;
    display: grid;
    grid-template-rows: auto auto;
    grid-row-gap: 24px;
  }
  .siedziba .firstRow {
    grid-row: 1/2;
    display: grid;
    grid-template-columns: 304px 304px 344px;
    grid-column-gap: 16px;
  }
  .siedziba .miejscowosc {
    width: 304px;
    grid-row: 2/3;
  }

  .adres {
    width: 100%;
    display: grid;
    grid-template-rows: auto auto auto;
    grid-row-gap: 24px;
  }
  .adres .firstRow {
    grid-row: 1/2;
    display: grid;
    grid-template-columns: 304px 304px 344px;
    grid-column-gap: 16px;
  }
  .adres .secondRow {
    grid-row: 2/3;
    display: grid;
    grid-template-columns: 424px 104px 84px;
    grid-column-gap: 16px;
  }
  .adres .thirdRow {
    grid-row: 3/4;
    display: grid;
    grid-template-columns: 304px 104px 304px 84px;
    grid-column-gap: 16px;
  }

  .adresZagraniczny {
    width: 100%;
    display: grid;
    grid-template-rows: auto auto auto;
  }
  .adresZagraniczny .firstRow {
    grid-row: 1/2;
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 8px;
  }
  .adresZagraniczny .secondRow {
    grid-row: 2/3;
    margin-top: 12px;
    display: grid;
    grid-template-columns: 424px 104px 84px;
    grid-column-gap: 16px;
  }
  .adresZagraniczny .thirdRow {
    grid-row: 3/4;
    margin-top: 24px;
    display: grid;
    grid-template-columns: 104px 304px 84px;
    grid-column-gap: 16px;
  }
  
  // .buttonGUS {
  //   margin-top: 12px;
  //   margin-left: 16px;
  // }

`
export default DaneIdentyfikacyjneStyle
